<template>
  <div>
    <hr>
    <div class="form-group">
      <div class="input-group">
        <label for="factor">Factor</label>
        <input autocomplete="off" type="text" id="factor" v-model="factor">
        <i class="bar"></i>
      </div>
      <div class="input-group"></div>
      <div class="input-group"></div>
    </div>
    <table class="table table-striped table-bordered">
      <thead class="thead-light">
      <tr>
        <th>MES</th>
        <th>VENTAS AÑO {{anioAnterior}}</th>
        <th>FACTOR</th>
        <th>PRESUPUESTO</th>
        <th>VENTAS AÑO {{anioActual}}</th>
        <th>% RESPECTO AÑO ANTERIOR</th>
        <th>% RESPECTO A PRESUPUESTO</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in dataConsolidado">
        <td>{{item.mes | upper}}</td>
        <td>
          <input type="text" @input="calcPresupuesto(item.venta_anio_anterior, factor)"
                 v-model="item.venta_anio_anterior">
        </td>
        <td>{{factor}} %</td>
        <td>{{calcPresupuesto(item.venta_anio_anterior, factor) | currency }}</td>
        <td><input type="text" v-model="item.venta_actual"></td>
        <td>{{porcentajeRespectoAnioAnterior(item) | setValue}} %</td>
        <td>{{porcentajeRespectoAPresupuesto(item) | setValue}} %</td>
      </tr>
      </tbody>
    </table>
    <button :disabled="disabled" class="btn btn-success btn-micro" @click="createQuerysAndSend">Actualizar</button>
  </div>
</template>

<script>
  import axios from "axios";

  export default {
    name: "tablaConsolidadoAnual",
    props: {
      dataConsolidado: {
        type: Array,
        default: () => {
          return []
        }
      },
      anioActual: "",
      anioAnterior: "",
      dataFactor: 0,
      disabled: false
    },
    data() {
      return {
        factor: this.dataFactor
      }
    },
    methods: {
      calcPresupuesto(valor, factor) {
        const resultFactor = parseInt(valor) * (factor / 100)
        valor = parseInt(valor) + resultFactor
        if (valor) return valor
        return 0
      },
      porcentajeRespectoAnioAnterior(item) {
        const total_neto = item.venta_actual !== undefined ? item.venta_actual : 0
        const diff = total_neto - item.venta_anio_anterior
        return Math.round((diff * 100) / item.venta_anio_anterior)
      },
      porcentajeRespectoAPresupuesto(item) {
        const total_neto = item.venta_actual !== undefined ? item.venta_actual : 0
        const diff = total_neto - this.calcPresupuesto(item.venta_anio_anterior, this.factor)
        return Math.round((diff * 100) / item.venta_anio_anterior)
      },
      createQuerysAndSend(){
        let querys = []
        for (let i in this.dataConsolidado) {
          querys.push(this.$axios.put('/finanzas/consolidado-ventas', {
            sucursalId: this.dataConsolidado[i].sucursal_id,
            anio: this.anioActual,
            anioAnterior: this.anioAnterior,
            mes: this.dataConsolidado[i].mes,
            factorPresupuesto: this.factor,
            porcentualAnioAnterior: this.porcentajeRespectoAnioAnterior(this.dataConsolidado[i] || 0),
            porcentualPresupuesto: this.porcentajeRespectoAPresupuesto(this.dataConsolidado[i] || 0),
            presupuesto: this.calcPresupuesto(this.dataConsolidado[i].venta_anio_anterior, this.factor) || 0,
            ventaActual: this.dataConsolidado[i].venta_actual || 0,
            ventaAnioAnterior: parseInt(this.dataConsolidado[i].venta_anio_anterior) || 0
          }))
        }
        this.disabled = true
        axios.all(querys).then(axios.spread((...responses) => {
          responses.forEach(res => {
            if (res.status === 201) {
              this.$swal('Correcto!', 'Consolidado creado correctamente...', 'success')
              this.disabled = false
            } else {
              this.disabled = false
              this.$swal("Error!", res, "error")
            }
          })
        })).catch(error => {
          this.$swal("Error!", error, "error")
        })
      }
    },
    filters: {
      setValue(value) {
        if (isNaN(value)) return 0
        if (value === Infinity) return 0
        return value
      }
    }
  }
</script>

<style scoped>

</style>
